import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingState from './LoadingState';

const ProtectedRoute = ({ children }) => {
  const { authStatus } = useAuth();
  const { pathname, search } = useLocation();

  if (authStatus === 'loading') {
    return <LoadingState label="Loading..." fullPage />;
  }

  if (authStatus !== 'authenticated') {
    return <Navigate to={`/login?redirect=${encodeURIComponent(pathname + search)}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
